import { EXPENSE_TYPE_ACTION_TYPES } from '../../actions/expense_type/expense_type_action';

const initialState = {
    page: 0,
    rowsPerPage: 10,
    totalCount: 0,
    collection: [],
    filters: {}
};

export const expenseTypes = (state = initialState, action) => {
    switch (action.type) {
        case EXPENSE_TYPE_ACTION_TYPES.GET_EXPENSE_TYPES_SUCCESS:
            return { ...state, collection: action.payload };
        case EXPENSE_TYPE_ACTION_TYPES.POST_EXPENSE_TYPE_SUCCESS:
            return { ...state, collection: [action.payload, ...state.collection], totalCount: state.totalCount + 1 };
        case EXPENSE_TYPE_ACTION_TYPES.PUT_EXPENSE_TYPE_SUCCESS:
            const updatedExpenseType = action.payload;
            return { ...state, collection: state.collection.map((expense) => expense.uuid !== updatedExpenseType.uuid ? expense : { ...expense, ...updatedExpenseType }) };
        case EXPENSE_TYPE_ACTION_TYPES.UPDATE_EXPENSE_TYPES_PAGINATION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
